const feedbackInitialState = {
  email: '',
  summary: '',
  description: '',
  attachments: [],
  showRecipients: false,
  recipients: '',
  validation: {
    email: 'Required',
    summary: 'Required',
    description: 'Required',
    attachments: ''
  }
}

export const feedbackReducer = (state=feedbackInitialState, action) => {
  switch (action.type) {
    case 'FIELD_UPDATE_FEEDBACK': {
      return Object.assign({}, state, action.payload)
    }
    case 'FIELD_VALIDATION_FEEDBACK': {
      state.validation = Object.assign({}, state.validation, action.payload)
      return Object.assign({}, state)
    }
    case 'FIELD_INPUT_FEEDBACK': {
      const myPayload = action.payload
      state.validation = Object.assign({}, state.validation, myPayload[1])
      return Object.assign({}, state, myPayload[0])
    }
    case 'FEEDBACK_SUCCESS': {
      return Object.assign({}, state, { email: '', summary: '', description: '', attachments: [], validation: {
        email: 'Required',
        summary: 'Required',
        description: 'Required',
        attachments: ''
      } })
    }
    default:
      return state
  }
}
